import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import _ from 'lodash';
import { renderMarkdown } from '~/functions/markdown';
import { useUpdateSelectedOptionsMutation } from '~/types/types';
export default defineComponent({
  inheritAttrs: false,
  props: {
    userInput: {
      type: Object,
      default: function _default() {}
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useUpdateSelectedOpt = useUpdateSelectedOptionsMutation(),
      updateSelectedOptions = _useUpdateSelectedOpt.mutate;
    var value = computed(function () {
      var values = props.userInput.selectedOptions.map(function (e) {
        return e.id;
      });
      // Use shouldAllowMultiple instead of isMultiple to determine return type
      return shouldAllowMultiple.value ? values : values[0];
    });
    var valueChange = function valueChange(value) {
      var values;
      if (_.isArray(value)) {
        values = value.filter(function (e) {
          return e !== null && e !== undefined;
        });
        // If shouldAllowMultiple is false and we're not dealing with existing multiple selections,
        // only keep the most recent selection
        if (!shouldAllowMultiple.value && values.length > 1) {
          values = [values[values.length - 1]];
        }
      } else if (value !== null && value !== undefined) {
        values = [value];
      } else {
        values = [];
      }
      var noneOption = props.options.find(function (e) {
        return e.label === 'None of the above';
      });
      if (noneOption !== undefined) {
        if (values.find(function (e) {
          return e === noneOption.id;
        })) {
          values = values.filter(function (e) {
            return e === noneOption.id;
          });
        }
      }
      updateSelectedOptions({
        userInputId: props.userInput.id,
        values: values
      });
    };
    var shouldAllowMultiple = computed(function () {
      // Allow multiple if either:
      // 1. isMultiple is true
      // 2. isMultiple is false BUT we have multiple values already selected
      return props.isMultiple || !props.isMultiple && Array.isArray(props.userInput.selectedOptions) && props.userInput.selectedOptions.length > 1;
    });
    return {
      updateSelectedOptions: updateSelectedOptions,
      renderMarkdown: renderMarkdown,
      value: value,
      valueChange: valueChange,
      shouldAllowMultiple: shouldAllowMultiple
    };
  }
});